/**
 * Updates the [water] amounts in How to prepare steps when another variant is selected.
 *
 * The section sits outside the product section that <product-variant-picker> re-renders, so it
 * listens for the picker's bubbling `shopify:product:select` event instead and reads the new
 * amount from the section's `[data-how-to-prepare-water-map]` script (variant id -> amount).
 */
document.addEventListener("shopify:product:select", async (event) => {
  let variant;
  try {
    ({ variant } = (await event.promise) ?? {});
  } catch {
    // Superseded or failed selection
    return;
  }

  // The event's variant id is a GID (gid://shopify/ProductVariant/123)
  const variantId = String(variant?.id ?? "").split("/").pop();
  if (!variantId) return;

  for (const map of document.querySelectorAll("[data-how-to-prepare-water-map]")) {
    const amounts = JSON.parse(map.textContent);
    if (!(variantId in amounts)) continue;

    const section = map.closest(".shopify-section") || document;
    for (const element of section.querySelectorAll("[data-how-to-prepare-water]")) {
      element.textContent = amounts[variantId] ?? "";
    }
  }
});
